export default __webpack_public_path__ + "static/media/Stragis.3c8954b7.jpg";